import { render } from "./AddButtonAndModal.vue?vue&type=template&id=16a99600&scoped=true"
import script from "./AddButtonAndModal.vue?vue&type=script&lang=js"
export * from "./AddButtonAndModal.vue?vue&type=script&lang=js"

import "./AddButtonAndModal.vue?vue&type=style&index=0&id=16a99600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a99600"]])

export default __exports__